import RootState from 'typings/RootState'
import { Event } from '../../types/event'

export const selectEvent = (state: RootState): Event => state.reportCommon.event
